module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADbSURBVHgBtdbbDcIwDAXQiAkyAiPA4mUD2IARyAiMcHFIqCLUJnZ8a8nqR1ufpsrDIUgAOEs+8jUQQ+rlvEreJWNosIQSiYU22LvWfn7ROrI23OgG9ovb/wjdaAd7rTVZqAprHnahJsyLTmGzqAuzohTMgtIwDSp5oWIKlI8N0GMwBWrCTkEfseaxgf2pz/+lHSzRJw0GixrMZQHlDgLGwodhu4J3a5spMI16vtb8Lgi7vroGiEcMlP0M9YgZoihNKgVToEu+EVGaVArWQUsjXG9mdGFhG+ja6n8AbhcgAm5tQDoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/m/close.png
// module id = OlPV
// module chunks = 1